module.exports = __webpack_public_path__ + "static/media/learning-3.77e0ea6a.png";